import React from 'react';

const FormulaSheetModal = ({ paper, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col">
                <div className="flex justify-between items-center mb-4 flex-shrink-0">
                    <h3 className="text-xl font-bold">Formula Sheet for {paper.name}</h3>
                    <button onClick={onClose} className="text-2xl font-bold text-gray-500 hover:text-gray-800">&times;</button>
                </div>
                <div className="overflow-y-auto space-y-4 pr-2">
                    {!paper.formulaSheetType || paper.formulaSheetType === 'none' ? (
                        <p className="text-gray-500 italic">No formula sheet is available for this paper.</p>
                    ) : paper.formulaSheetType === 'text' ? (
                        <div className="bg-gray-50 p-4 rounded border">
                            <pre className="whitespace-pre-wrap font-sans text-sm">{paper.formulaSheetContent}</pre>
                        </div>
                    ) : (
                        Array.isArray(paper.formulaSheetContent) && paper.formulaSheetContent.map((url, index) => (
                            <img 
                                key={index} 
                                src={url} 
                                alt={`Formula Sheet Page ${index + 1}`} 
                                className="w-full h-auto border rounded-md shadow-sm" 
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default FormulaSheetModal;